import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';
import Relay from 'react-relay';
import useRelay from 'react-router-relay';
import 'roboto-fontface';
import { applyRouterMiddleware, Router, Route, hashHistory, Redirect } from 'react-router';
import NProgress from 'react-nprogress';

import initRelayNetwork from './js/RelayNetworkLayer';
import App from './js/Containers/App';
import ContactsContainer from './js/Containers/ContactsContainer';
import FavoritesContainer from './js/Containers/FavoritesContainer';
import SchedulerContainer from './js/Containers/SchedulerContainer';
import MeetingroomOverviewContainer from './js/Containers/MeetingroomOverviewContainer';
import MeetingroomDetailContainer from './js/Containers/MeetingroomDetailContainer';
import renderOrDisplayErrorPage from './js/libs/RenderOrDisplayErrorPage';
import MeetingRoomLocations from './js/Components/MeetingRooms/MeetingRoomLocations';
import MeetingRoomLanding from './js/Components/MeetingRooms/MeetingRoomLanding';
import MeetingRoomList from './js/Components/MeetingRooms/MeetingRoomList';
import SignupStatusContainer from './js/Containers/SignupStatusContainer';
import { prepareMeetingroomParams } from './js/libs/RelayRoutes';
import { initErrorLogging } from './js/libs/Logger';
import { setPollForNewVersionDelay } from './js/libs/VersionCheck';
import './css/App.css';
import '../node_modules/react-nprogress/nprogress.css';

initErrorLogging(); // start error tracking
setPollForNewVersionDelay(); // starting looking for new app version

const ContactViewQueries = {
  viewer: () => Relay.QL`query { viewer }`,
};

Relay.injectNetworkLayer(initRelayNetwork());

// disable loading bar spinner
NProgress.configure({ showSpinner: false });

ReactDOM.render(
  <Router
    environment={Relay.Store}
    render={applyRouterMiddleware(useRelay)}
    history={hashHistory}
    forceFetch={true}
  >
    <Redirect from="/" to="/contacts" />
    <Route
      path="/meetingrooms"
      component={MeetingRoomLanding}
      render={renderOrDisplayErrorPage}
    />
    <Route
      path="/meetingrooms/locations"
      component={MeetingRoomLocations}
      queries={ContactViewQueries}
      render={renderOrDisplayErrorPage}
    />
    <Route
      path="/meetingrooms/list"
      component={MeetingRoomList}
      queries={ContactViewQueries}
      render={renderOrDisplayErrorPage}
    />
    <Route
      path="/display-overview-meetingrooms" /* This is for backwards compatibility */
      component={MeetingroomOverviewContainer}
      queries={ContactViewQueries}
      render={renderOrDisplayErrorPage}
      prepareParams={prepareMeetingroomParams}
    />
    <Route
      path="meetingroom/:id"
      component={MeetingroomDetailContainer}
      queries={ContactViewQueries}
    />
    <Route
      path="/"
      component={App}
      queries={ContactViewQueries}
      render={renderOrDisplayErrorPage}
    >
      <Route
        path="favourites"
        queries={ContactViewQueries}
        component={FavoritesContainer}
        render={renderOrDisplayErrorPage}
      />
      <Route path="contacts" component={ContactsContainer} queries={ContactViewQueries} />
      <Route path="contacts/:tab" component={ContactsContainer} queries={ContactViewQueries} />
      <Route path="scheduler" component={SchedulerContainer} queries={ContactViewQueries} view="scheduler" />
      <Route path="calendar" component={SchedulerContainer} queries={ContactViewQueries} view="calendar" />
    </Route>
    <Route
      path="signup-status"
      component={SignupStatusContainer}
    />

  </Router>,
  document.getElementById('users')
);



// WEBPACK FOOTER //
// ./src/index.js